import { AbstractControlOptions, FormArray, Validators } from '@angular/forms';
import { PrFormAbstract } from '@app/components/pr-form/pr-form.abstract';

import { Injectable } from '@angular/core';
import {
  OperationAntiMoneyLaundering,
  Parameters,
  PledgeRead,
} from '@app/forms/subscription/definition/interface/Pledge';
import { FormConfig } from '@app/forms/subscription/definition/types/subscription';
import * as _ from 'lodash';
@Injectable({
  providedIn: 'root',
})
export abstract class EaSubscriptionBuilder extends PrFormAbstract {
  generate(entity: PledgeRead) {
    const parameters: Parameters = {
      ...entity?.parameters,
    };

    let options: AbstractControlOptions = {};
    const formConfig: FormConfig<
      Pick<
        OperationAntiMoneyLaundering,
        'venteEnPresenceDesParties' | 'clientPresentAuMomentIdentification'
      >
    > = {
      venteEnPresenceDesParties: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering?.venteEnPresenceDesParties,
        )
          ? true
          : parameters?.operationAntiMoneyLaundering?.venteEnPresenceDesParties,
        Validators.required,
      ],
      clientPresentAuMomentIdentification: [
        _.isNil(
          parameters?.operationAntiMoneyLaundering
            ?.clientPresentAuMomentIdentification,
        )
          ? true
          : parameters?.operationAntiMoneyLaundering
              ?.clientPresentAuMomentIdentification,
        Validators.required,
      ],
    };
    return this.formBuilder.group(formConfig, options);
  }

  get owners() {
    return this.form.get('owners') as FormArray;
  }

  extract() {
    const formValue = _.cloneDeep(this.form.value);
    return {
      operationAntiMoneyLaundering: {
        ...formValue,
      },
    };
  }
}
